<script>
import { createEventDispatcher, tick } from 'svelte';
import Icon from 'svelte-awesome';
import {faPen} from '@fortawesome/free-solid-svg-icons';
import { Button, Tooltip} from 'svelte-materialify';
const dispatch = createEventDispatcher();

  export let value = "";
  export let user = null;
  let originalValue = "";
  let isEditable = false;
  let isHovered = false;
  let editableDiv;

  function save() {
    event.stopPropagation();
    isEditable = false;
    let childElement = editableDiv.firstElementChild;
    childElement.classList.remove('editing-element');
    dispatch('save', childElement.innerText);
  }

  async function makeEditable() {
    if (isEditable) return;
    if ((!user)) {
      dispatch('not-owner','change the board name');
      return;
    }
    originalValue = value;
    isEditable = true;
    let childElement = editableDiv.firstElementChild;
    if (childElement) {
      childElement.setAttribute('contenteditable', isEditable);
    }
    await tick(); // Wait for the DOM to update
    childElement.classList.add('editing-element');
    childElement.focus(); // Focus the contenteditable div

    // Create a Range object and set its position to the end of the content
    const range = document.createRange();
    // range.selectNodeContents(editableDiv);
    range.selectNodeContents(childElement);
    range.collapse(false); // false means collapse to end

    // Get the Selection object and add the Range
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  function cancel() {
    event.stopPropagation();
    isEditable = false;
    let childElement = editableDiv.firstElementChild;
    childElement.classList.remove('editing-element');
    childElement.innerText = originalValue;
}
</script>
              
<div class="editable {user ? '' : 'disabled'}" on:click={makeEditable}>
  <div class="content">
      <div bind:this={editableDiv} Xcontenteditable={isEditable ?'true':'false'}
        style={isEditable ? 'width: auto; padding-right: 12px;' : 'width: auto;'}  class="{isEditable ? 'editable-wrapper-editing' : 'editable-wrapper-not-editing'}"> 
        <slot></slot>
      </div>
      {#if isEditable}
        <Button class="primary small" on:click={save}>✓</Button>
        <Button class="secondary small" on:click={cancel}>x</Button>
      {/if}
  </div> 

  <div class="edit-icon">
    {#if !isEditable}
      <div class="icon-action-small" id="edit-board-name">    
      <Icon data={faPen} scale="0.86" style="color: var(--aqua) !important; cursor: hand;" />
    </div>
    {/if}
  </div>
</div>

<style>
  .editable {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between; /* Separate text and pen icon */
    align-items: center; /* Align items vertically */
    cursor: pointer;
    Xborder: 1px solid #ccc;
    border-radius: 4px;
    outline: none !important;
  }
  .content {
    display: flex;
    flex-direction: row;
    margin: 4px 0 !important;
    justify-content: flex-end;
  }
  .editable-wrapper-editing{
    outline: none !important;
    border: 1px solid var(--aqua);
    border-radius: 4px;
    padding-left: 6px;
    padding-right: 6px;
    background-color: white;
  }
  .editable-wrapper-not-editing {
    outline: none;
    border: none;
  }
  :global(.editing-element){
    margin: 0 !important;
    padding-right: 38px !important;
  }
  .edit-icon {
    display: flex;
    opacity: 0;
    align-items: center;
    margin-left: 8px;
    transition: opacity 0.5s ease-in-out;
  }
  .editable:hover .edit-icon {
    opacity: 1;
  }  
  .editable.disabled:hover .edit-icon {
    opacity: 0.5;
  }
  .icon-disabled:hover {
    opacity: 0.4 !important;
    pointer-events: none !important; 
    cursor: none !important;
  }
  :global(button.small){margin-left: 4px !important; height: 24px !important; min-width: 48px !important;}
</style>